module.exports = "pegasus/assets/square-twitter.png";